var render = function render(){var _vm=this,_c=_vm._self._c;return _c('currency-input',{directives:[{name:"currency",rawName:"v-currency",value:({currency: null}),expression:"{currency: null}"}],attrs:{"name":_vm.input_name},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})
}
var staticRenderFns = []

export { render, staticRenderFns }